import React from "react";
import { ProductPartialRootScreenContextType } from "./types";

export const ProductPartialRootScreenContext = React.createContext<
  ProductPartialRootScreenContextType | undefined
>(undefined);
